export const CURRENCY_INFO = {
  "huf": { digits: 0, locale: 'hu-HU', render: function (val: any) { return val + " Ft"; } },
  "eur": { digits: 2, locale: 'de-DE', render: function (val: any) { return "€" + val; } },
  "gbp": { digits: 2, locale: 'en-GB', render: function (val: any) { return "£" + val; } },
  "czk": { digits: 2, locale: 'cs-CZ', render: function (val: any) { return val + " Kč"; } },
  "usd": { digits: 2, locale: 'en-US', render: function (val: any) { return "$" + val; } },
  "pln": { digits: 2, locale: 'pl-PL', render: function (val: any) { return val + " zł"; } },
  "chf": { digits: 2, locale: 'de-DE', render: function (val: any) { return val + " CHF"; } },
  "unknown": { digits: 2, locale: 'en-US', render: function (val: any) { return val; } }
}

export function formatPriceForcedCurrency(price: number, currency: string) {
  price = +price;
  // @ts-ignore
  let currInfo = CURRENCY_INFO[currency] || CURRENCY_INFO.unknown;
  return currInfo.render(price.toLocaleString([currInfo.locale], { maximumFractionDigits: currInfo.digits, minimumFractionDigits: currInfo.digits }));
}

/**
 *
 * copied from quote.js
 *
 * @param {*} price
 * @param {"huf" | "eur" | "gbp"} currency
 */
export function formatPriceNew(price: number|string, currency: string) {
  price = +price;
  var isMinus = price < 0;
  price = Math.abs(price)
  // @ts-ignore
  var currInfo = CURRENCY_INFO[currency] || CURRENCY_INFO.unknown;
  var rendered = currInfo.render(price.toLocaleString([currInfo.locale], { maximumFractionDigits: currInfo.digits, minimumFractionDigits: currInfo.digits }));
  if (isMinus) {
    rendered = "- " + rendered;
  }
  return rendered;
}
